import React, { useState } from 'react';
import MapDisplay from './MapDisplay';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import markersData from '../data/markers.json';

export default function AdventureFeedCarousel({ trackId, trackUrl }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const markers = markersData[trackId] || [];
  const totalSlides = 1 + markers.length; // 1 for map + N for photos

  const nextSlide = () => setCurrentIndex((prev) => (prev + 1) % totalSlides);
  const prevSlide = () => setCurrentIndex((prev) => (prev - 1 + totalSlides) % totalSlides);

  return (
    <div style={{ position: 'relative', width: '100%', height: '400px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #262626', background: '#000' }}>
      
      {/* Current Slide Content */}
      <div style={{ width: '100%', height: '100%', position: 'relative' }}>
        {currentIndex === 0 ? (
          <MapDisplay trackUrl={trackUrl} markers={markers} />
        ) : (
          <div style={{ width: '100%', height: '100%', position: 'relative', overflow: 'hidden', background: '#000' }}>
            <div style={{
              position: 'absolute', top: '-10%', left: '-10%', right: '-10%', bottom: '-10%',
              backgroundImage: `url(${markers[currentIndex - 1].image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              filter: 'blur(20px)',
              opacity: 0.6,
              zIndex: 0
            }} />
            <img 
              src={markers[currentIndex - 1].image} 
              alt="Adventure" 
              style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'relative', zIndex: 1 }} 
            />
            {markers[currentIndex - 1].caption && (
              <div style={{
                position: 'absolute',
                bottom: 0, left: 0, right: 0,
                padding: '30px 20px 20px 20px',
                background: 'linear-gradient(transparent, rgba(0,0,0,0.9))',
                color: '#fff',
                fontWeight: 600
              }}>
                {markers[currentIndex - 1].caption}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Navigation Buttons */}
      {totalSlides > 1 && (
        <>
          <button onClick={prevSlide} className="carousel-nav-btn left">
            <FaChevronLeft />
          </button>
          
          <button onClick={nextSlide} className="carousel-nav-btn right">
            <FaChevronRight />
          </button>
        </>
      )}

      {/* Slide Indicators */}
      {totalSlides > 1 && (
        <div style={{
          position: 'absolute', top: '10px', right: '10px',
          background: 'rgba(0,0,0,0.6)', padding: '4px 12px',
          borderRadius: '12px', fontSize: '0.8rem', color: '#fff',
          fontFamily: 'monospace', zIndex: 10
        }}>
          {currentIndex === 0 ? 'Map' : `${currentIndex} / ${markers.length}`}
        </div>
      )}
    </div>
  );
}
